import React from 'react';

const Contact = () => {
    return (
        <div className='bg-blue-900 text-white grid grid-cols-1 lg:grid-cols-2 gap-5 p-12'>
            <h2 className='lg:text-6xl text-2xl'>Thank you for putting your trust in me </h2>
            <div>
                <h2 className='lg:text-4xl mb-5'>Let's Work Together</h2>
                <p className='w-4/5'>Thank you for being so generous with your time, and for your careful research regarding our personal preferences prior to my photography session with you.</p>
            </div>
        </div>
    );
};

export default Contact;